// extracted by mini-css-extract-plugin
export default {"button":"styles__button___sGJyf","content":"styles__content___M2dOU"};